import { render } from "./TelemedicineContent.vue?vue&type=template&id=1227adac&scoped=true"
import script from "./TelemedicineContent.vue?vue&type=script&lang=js"
export * from "./TelemedicineContent.vue?vue&type=script&lang=js"

import "./TelemedicineContent.vue?vue&type=style&index=0&id=1227adac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1227adac"]])

export default __exports__